import { render } from "./Sales.vue?vue&type=template&id=000fbe8f&scoped=true"
import script from "./Sales.vue?vue&type=script&lang=js"
export * from "./Sales.vue?vue&type=script&lang=js"

import "./custom-sales.scss?vue&type=style&index=0&id=000fbe8f&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000fbe8f"]])

export default __exports__